import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './fonts.css'

import App from './App'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
